module.exports = __webpack_public_path__ + "static/cheryl-d12dbe041c36100f1874acb7e1266609.jpg";